const serviceLinks = [
  { label: 'Roof Replacement', href: '#services' },
  { label: 'Roof Repair', href: '#services' },
  { label: 'Storm Damage Restoration', href: '#services' },
  { label: 'Siding & Gutters', href: '#services' },
  { label: 'Free Roof Inspection', href: '#contact' },
];

const areaLinks = [
  { label: 'Houston, TX', href: '#areas' },
  { label: 'Baton Rouge, LA', href: '#areas' },
  { label: 'Lafayette, LA', href: '#areas' },
  { label: 'Charlotte, NC', href: '#areas' },
  { label: 'Atlanta, GA', href: '#areas' },
];

export default function Footer() {
  return (
    <footer className="bg-[#111111] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Main Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/d22c6399-eb7f-4911-8e5b-8acfdada154e/b8a83447-7c28-4bdb-882a-4824783c4ae8_logo.webp?v=39bdc8d05d88a7fa016d38d80d5cdc5e"
                alt="PRA Roof Contractors, Inc."
                className="h-28 w-auto object-contain brightness-200"
              />
            </div>
            <p className="text-white/40 text-xs leading-relaxed mb-5">
              The Southeast's trusted roofing and storm restoration authority since 1998. Serving Texas, Louisiana, North Carolina, and Georgia.
            </p>
            <div className="flex gap-3">
              <a href="tel:2813779180" className="w-9 h-9 flex items-center justify-center bg-white/5 hover:bg-[#c0392b] rounded-full transition-colors cursor-pointer">
                <i className="ri-phone-line text-white text-sm"></i>
              </a>
              <a href="mailto:info@praroof.com" className="w-9 h-9 flex items-center justify-center bg-white/5 hover:bg-[#c0392b] rounded-full transition-colors cursor-pointer">
                <i className="ri-mail-line text-white text-sm"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-sm mb-4">Services</h4>
            <ul className="flex flex-col gap-2.5">
              {serviceLinks.map((link, i) => (
                <li key={i}>
                  <a href={link.href} className="text-white/40 hover:text-white text-xs transition-colors cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-white font-bold text-sm mb-4">Service Areas</h4>
            <ul className="flex flex-col gap-2.5">
              {areaLinks.map((link, i) => (
                <li key={i}>
                  <a href={link.href} className="text-white/40 hover:text-white text-xs transition-colors cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-sm mb-4">Contact Us</h4>
            <div className="flex flex-col gap-3">
              <a href="tel:2813779180" className="flex items-center gap-2.5 text-white/40 hover:text-white text-xs transition-colors cursor-pointer">
                <i className="ri-phone-line text-[#c0392b] text-sm"></i>
                (281) 377-9180
              </a>
              <a href="mailto:info@praroof.com" className="flex items-center gap-2.5 text-white/40 hover:text-white text-xs transition-colors cursor-pointer">
                <i className="ri-mail-line text-[#c0392b] text-sm"></i>
                info@praroof.com
              </a>
              <div className="flex items-start gap-2.5 text-white/40 text-xs">
                <i className="ri-map-pin-line text-[#c0392b] text-sm mt-0.5"></i>
                <span>Houston, TX (HQ)<br />+ Southeast US Locations</span>
              </div>
            </div>

            <a
              href="#contact"
              className="inline-flex items-center gap-2 mt-6 bg-[#c0392b] hover:bg-[#a93226] text-white font-bold px-5 py-2.5 rounded-full text-xs transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-check-line"></i>
              Free Inspection
            </a>
          </div>
        </div>

        {/* Watermark */}
        <div className="border-t border-white/5 pt-6 overflow-hidden">
          <div className="text-center mb-4">
            <span className="text-white/[0.04] font-black text-6xl md:text-8xl lg:text-9xl tracking-tighter select-none whitespace-nowrap">
              PRA ROOF
            </span>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-white/25 text-xs">
              © {new Date().getFullYear()} PRA Roof Contractors, Inc. All rights reserved.
            </p>
            <p className="text-white/25 text-xs">
              Licensed &amp; Insured · Owens Corning Platinum Preferred Contractor
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
